module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-preset-react-app/~/babel-runtime/regenerator/index.js
 ** module id = 844
 ** module chunks = 0
 **/